import { nwccDomain } from "@js/nwcc-domains.js";
import { setDataCache, getFromCache, hasCacheData } from "@js/service/cache.js";

const baseUrl = `${nwccDomain}/awdb`;

export async function getAllDataFiles() {
    return Promise.all([
        getDataFile("PREC"),
        getDataFile("WTEQ"),
        getDataFile("TAVG"),
        getDataFile("SNWD"),
        getDataFile("SRVO"),
    ]);
}

export async function getDataFile(element) {
    const url = `${baseUrl}/sitedata/metadata/${element}/metadata.json`;

    if (hasCacheData(url)) {
        return await getFromCache(url);
    } else {
        const response = await fetch(url);
        const jsonData = await response.json();
        setDataCache(jsonData, url);
        return jsonData;
    }
}
